export const INIT_SCORES = '[Scores] init';
export const REGISTER_KILL = '[Scores] register kill';
export const INCREASE_REPUTATION = '[Scores] increase reputation';
export const REGISTER_POLICE_SCORE_CHANGE =
  '[Scores] register police score change';

export const RESET_POLICE_SCORE = '[Scores] register police score reset';
